export default function ResultNumbers({ numbers }) {
  const msg = numbers === 1 ? `1 result` : `${numbers} results`;
  return (
    <div>
      <span className="pill pill-neutral">{msg}</span>
    </div>
  );
}
